// extracted by mini-css-extract-plugin
export default {"description":"Description_description__kvLlq","title":"Description_title__Hn13d","body":"Description_body__56UhD","text":"Description_text__C2BFC","img":"Description_img__vyWpo"};